<template>
  <div class="vc-product-properties">
    <slot />
  </div>
</template>
